import ImageFieldModal from '$tablet-app/src/app/components/ImageField/ImageFieldModal';
import { LocalImage } from '$tablet-app/src/app/images/types';
import useBool from '$tablet-app/src/app/utils/state/useBool';
import React, { FC } from 'react';
import { StyleProp, TouchableOpacity, ViewStyle } from 'react-native';

interface Props {
  style?: StyleProp<ViewStyle>;

  imageUrl?: string;

  onChange?: (imageData: { url?: string; imageUpload?: LocalImage }) => void;

  children?: React.ReactNode;
}

const ImagePicker: FC<Props> = ({ style, imageUrl, children, onChange }) => {
  const [visible, show, hide] = useBool(false);

  const onSubmit = (imageData: { url?: string; imageUpload?: LocalImage }) => {
    hide();
    onChange?.(imageData);
  };

  return (
    <>
      <TouchableOpacity style={style} onPress={show}>
        {children}
      </TouchableOpacity>

      {visible ? (
        <ImageFieldModal
          onCancel={hide}
          onSubmit={onSubmit}
          publicUrl={imageUrl}
        />
      ) : null}
    </>
  );
};

export default ImagePicker;
